/**
 * Copyright (c) 2022-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { skipToken, useSuspenseQuery } from "@apollo/client/react";
import { type ButtonHTMLAttributes, type Ref, Suspense, useContext } from "react";
import { FavoriteButton as UIFavoriteButton } from "../../components/MyNdla/FavoriteButton";
import { resourceConnectionsQuery } from "../../mutations/folder/folderQueries";
import { AuthContext } from "../AuthenticationContext";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "size" | "type"> {
  ref?: Ref<HTMLButtonElement>;
  path: string;
}

export const FavoriteButton = (props: Props) => (
  <Suspense fallback={<UIFavoriteButton isFavorite={false} {...props} />}>
    <FavoriteButtonContent {...props} />
  </Suspense>
);

const FavoriteButtonContent = (props: Props) => {
  const { authenticated } = useContext(AuthContext);
  const connectionsQuery = useSuspenseQuery(
    resourceConnectionsQuery,
    !authenticated ? skipToken : { variables: { path: props.path } },
  );
  return <UIFavoriteButton isFavorite={!!connectionsQuery.data?.myNdlaResourceConnections?.length} {...props} />;
};
